export default {
  /**
   * Indicates that the visitor has logged out
   * @returns {Boolean}
   */
  isLoggedIn: state => state.session != null && !state.session.hasExpired,
  /**
   * Indicates that the visitor has logged out
   * @returns {Boolean}
  */
  isLoggedOut: state => state.session == null || state.session.hasExpired,
  /**
   * Session token
   * @returns {String}
   */
  token: state => state.session?.token,
  /**
   * Logged in account
   * @returns {Account}
   */
  account: state => state.session?.account,
  /**
   * Identifier of the logged in account
   * @returns {Account}
  */
  accountId: state => state.session?.account?.id,
  /**
   * Checks whether current account is a super-administrator
   * @returns {Boolean}
   */
  isSuperAdministrator: state => state.session?.account?.isSuperAdministrator || false,

  /**
   * Checks whether account can use the specified feature
   * @param {String} feature Name of the feature to check
   * @returns {Boolean}
   */
  canUse (feature) {
    return this.guardian?.guardian.canUse(feature)
  },

  /**
   * Checks whether account can use all the specified features
   * @param {Array[String]} features Name of features to check
   * @returns {Boolean}
   */
  canUseAll (features) {
    return this.guardian?.canUseAll(features)
  },

  /**
   * Checks whether account can use any of the specified features
   * @param {Array[String]} features Name of features to check
   * @returns {Boolean}
   */
  canUseAny (features) {
    return this.guardian?.canUseAny(features)
  },

  /**
   * Checks whether account cannot use the specified feature
   * @param {String} feature Name of feature to check
   * @returns {Boolean}
   */
  cannotUse (featureName) {
    return !this.guardian?.canUse(featureName)
  },

  /**
   * Checks whether account cannot use some or all the specified features
   * @param {Array[String]} features Name of features to check
   * @returns {Boolean}
   */
  cannotUseAll (features) {
    return !(this.guardian?.canUseAll(features))
  },

  /**
   * Checks whether account cannot use any of the specified features
   * @param {Array[String]} features Name of features to check
   * @returns {Boolean}
   */
  cannotUseAny (features) {
    return !(this.guardian?.canUseAny(features))
  },

  /**
   * Current user / account
   * @returns {Account}
   */
  currentUser: state => state.session?.account,

  /**
   * Current avatar
   * @returns {Avatar}
   */
  currentAvatar: state => state.session?.account?.avatar,

  /**
   * Global application preferences dictionary
   * @returns {Object}
   */
  globalPreferences: state => state.session?.preferences || {},

  /**
   * User preferences dictionary
   * @returns {Object}
   */
  userPreferences: state => state.session?.account?.preferences || {},

  /**
   * Avatar preferences dictionary for the current active avatar
   * @returns {Object}
   */
  avatarPreferences (state) {
    return this.currentAvatar?.preferences || {}
  }
}
